import {
  useCallback, useContext, useEffect, useState,
} from 'react';
import { AppContext } from '../../../providers/authProvider';
import api from '../../../api/req';
import { dateFormat } from '../../../api/utils';

const SERVICE_URL = '/api/service/indexingcontracts/';

const useIndexongContrctService = () => {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [success, setSuccess] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [contracts, setContracts] = useState([]);

  const [mont, setMont] = useState(() => {
    const d = new Date();
    return d.getMonth();
  });
  const [year, setYear] = useState(() => {
    const d = new Date();
    return d.getFullYear();
  });

  const { currentUser, auth } = useContext(AppContext);

  const [org, setOrg] = useState(currentUser.org);

  const onLoad = useCallback(
    () => {
      const req = async () => {
        const r = await api.get(SERVICE_URL, auth, { org_id: org.id });
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return r.json();
      };
      if (org.id) {
        setLoading(true);
        setErr(null);
        setSuccess(false);
        req()
          .then((d) => setContracts(d.map((c) => ({
            ...c,
            checked: true,
            repr: `${c.number} від ${dateFormat(c.date)} (${c.payer.repr})`,
          }))))
          .catch((e) => setErr(e.message))
          .finally(() => setLoading(false));
      }
    },
    [auth, org.id],
  );

  useEffect(
    () => onLoad(),
    [onLoad],
  );

  const onSave = useCallback(
    () => {
      const req = async () => {
        const ids = contracts.filter((c) => c.checked).map((c) => c.id);
        const d = new Date(year, mont, 1);
        d.setMinutes(-d.getTimezoneOffset());
        const r = await api.post(SERVICE_URL, auth, { org_id: org.id, date: d.toJSON().substring(0, 10), contracts: ids });
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return true;
      };
      setLoading(true);
      setErr(null);
      setSuccess(false);
      req()
        .then(() => setSuccess(true))
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    },
    [auth, contracts, mont, org.id, year],
  );

  const onSetOrg = useCallback(
    (v) => {
      if (currentUser.is_superuser) setOrg(v);
    },
    [currentUser.is_superuser],
  );

  const onToggleContract = useCallback(
    (id) => setContracts(
      (cs) => cs.map((c) => (c.id === id ? { ...c, checked: !c.checked } : c)),
    ),
    [],
  );

  const onAll = useCallback(
    (m) => setContracts((cs) => cs.map((c) => ({ ...c, checked: m }))),
    [],
  );

  return ({
    loading,
    err,
    success,
    org,
    onSetOrg,
    contracts,
    currentUser,
    onLoad,
    onSave,
    onToggleContract,
    onAll,
    mont,
    setMont,
    year,
    setYear,

  });
};

export default useIndexongContrctService;
